module.exports = __webpack_public_path__ + "static/media/creativeshead2.29a8d24a.jpg";